/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PcmsHubJuvenileLifecycleResult { 
    /**
     * Exact opaque CRD ProgramReferral OID; preserve case and value without normalization
     */
    crdReferralId?: string | null;
    outcome?: PcmsHubJuvenileLifecycleResult.OutcomeEnum;
    pcmsReferralId?: number;
    referralStatus?: PcmsHubJuvenileLifecycleResult.ReferralStatusEnum;
}
export namespace PcmsHubJuvenileLifecycleResult {
    export const OutcomeEnum = {
        Created: 'CREATED',
        Removed: 'REMOVED',
        Unchanged: 'UNCHANGED'
    } as const;
    export type OutcomeEnum = typeof OutcomeEnum[keyof typeof OutcomeEnum];
    export const ReferralStatusEnum = {
        Pending: 'PENDING',
        Accepted: 'ACCEPTED',
        Active: 'ACTIVE',
        Completed: 'COMPLETED',
        Cancelled: 'CANCELLED',
        Rejected: 'REJECTED',
        Removed: 'REMOVED'
    } as const;
    export type ReferralStatusEnum = typeof ReferralStatusEnum[keyof typeof ReferralStatusEnum];
}


